var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlifshopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 31,
    r: 28,
    fill: "#FFB500"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3677 20.5959H31.9998L24.839 38.2191H29.4327L34.6838 24.6072L39.9369 38.2191H44.5306L37.3677 20.5959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7427 49.5957L32.7051 49.5915H32.703H32.7009H32.6989H32.6968C29.9982 49.3202 27.4019 48.5041 25.0581 47.2248C20.5354 44.7558 16.9581 40.5628 15.3928 35.2345C13.8296 29.9041 14.5726 24.4444 17.0416 19.9258C18.3127 17.5987 20.0387 15.5221 22.1424 13.842L22.1842 13.8086C22.1863 13.8065 22.1884 13.8065 22.1884 13.8044C25.3002 11.252 29.1133 9.55307 33.2415 9.01878C33.2624 9.0167 33.398 9.00209 33.4189 9L35.1512 13.2597C35.1261 13.2618 34.9842 13.2743 34.9592 13.2743C31.2776 13.5039 27.861 14.8876 25.1123 17.0958C25.0685 17.1312 25.0268 17.1646 24.9829 17.2001C24.9141 17.2565 24.8452 17.3128 24.7784 17.3713L24.7742 17.3754L24.7701 17.3796L24.7659 17.3817L24.7617 17.3838L24.7575 17.388C24.7388 17.4026 24.7221 17.4172 24.7033 17.4318C23.1442 18.7174 21.8586 20.2827 20.9048 22.0296C18.9763 25.5588 18.3961 29.8248 19.6192 33.9906C20.8422 38.1564 23.6347 41.4311 27.1618 43.3574C29.0298 44.378 31.1064 45.0208 33.2645 45.2191C37.9625 45.6052 42.3912 44.0942 45.7785 41.3184C45.9434 41.1827 46.1062 41.0449 46.2648 40.9051L47.9992 45.1732C43.7937 48.3935 38.4195 50.1049 32.7427 49.5957Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0.660378,
    y: 0.886792,
    width: 68.6792,
    height: 68.6792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.11321
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.11321
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.709804 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.22642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.16981
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlifshopLogo);
export default __webpack_public_path__ + "static/media/alifshop-logo.aebb66edc31035fb75ebb20c863c9644.svg";
export { ForwardRef as ReactComponent };